"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.sort.js");

var _react = _interopRequireWildcard(require("react"));

var _usePreviousValue = _interopRequireDefault(require("../../hooks/usePreviousValue.js"));

require("./index.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ItemList(_ref) {
  let {
    allowedIdsList,
    items,
    handleSelect,
    onHover,
    possibleItemsConflicts
  } = _ref;
  const [searchText, setSearchText] = (0, _react.useState)();
  const previousAllowedIdsLength = (0, _usePreviousValue.default)(allowedIdsList.length);
  const displayItems = (0, _react.useMemo)(() => {
    let results = items.filter(item => allowedIdsList.includes(item.id));

    if (searchText !== null && searchText !== void 0 && searchText.length) {
      results = results.filter(item => item.name.toLowerCase().includes(searchText));
    }

    return results.sort((itemA, itemB) => itemA.name.localeCompare(itemB.name));
  }, [allowedIdsList, items, searchText]);
  (0, _react.useEffect)(() => {
    if (previousAllowedIdsLength !== allowedIdsList.length) {
      setSearchText('');
    }
  }, [previousAllowedIdsLength, allowedIdsList.length]);

  if (!allowedIdsList) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tgb-select-list-wrapper",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "text",
      onChange: e => {
        setSearchText(e.target.value);
      },
      placeholder: "Search by item name",
      ref: input => {
        if (input != null) {
          input.focus();
        }
      },
      value: searchText
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
      style: {
        width: '100%',
        borderCollapse: 'collapse',
        verticalAlign: 'middle'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("th", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
            children: "NAME"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
            children: "ERGONOMICS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
            children: "RECOIL"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: displayItems.map((displayItem, index) => {
          const conflict = possibleItemsConflicts.find(x => x.ids.includes(displayItem.id));
          let conflictText;

          if (conflict) {
            conflictText = "This mod conflicts with '".concat(conflict.item.name, "'");
          }

          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
            className: "tgb-selected-item ".concat(conflict && 'tgb-conflict'),
            onClick: handleSelect.bind(this, displayItem.id),
            onMouseEnter: onHover === null || onHover === void 0 ? void 0 : onHover.bind(this, displayItem.id),
            onMouseLeave: onHover === null || onHover === void 0 ? void 0 : onHover.bind(this, false),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                className: "tgb-selected-item-image",
                alt: displayItem.name,
                loading: "lazy",
                src: displayItem.gridImageLink
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
              className: "tgb-selected-item-name",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: displayItem.name
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  className: "tgb-selected-item-name-conflict",
                  children: conflictText
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
              children: displayItem.itemProperties.Ergonomics || 0
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("td", {
              children: [displayItem.itemProperties.Recoil || 0, "%"]
            })]
          }, "selected-item-".concat(index));
        })
      })]
    })]
  });
}

var _default = ItemList;
exports.default = _default;